import React, { useState, useEffect } from 'react';
import './EditorStyles.css';

const ContactDetailsEditor = () => {
  const [contactDetails, setContactDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadContactDetails();
  }, []);

  const loadContactDetails = async () => {
    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/contact-details`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (data.success) {
        setContactDetails(data.data);
      }
    } catch (error) {
      console.error('Error loading contact details:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (detail) => {
    setSaving(true);
    setMessage('');

    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/contact-details/${detail.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          value_ar: detail.value_ar,
          value_en: detail.value_en,
          url: detail.url,
          is_active: detail.is_active,
          display_order: detail.display_order
        })
      });

      const data = await response.json();
      if (data.success) {
        setMessage('تم حفظ بيانات التواصل بنجاح!');
        setTimeout(() => setMessage(''), 3000);
        loadContactDetails();
      } else {
        setMessage(data.message || 'حدث خطأ');
      }
    } catch (error) {
      setMessage('خطأ في الاتصال');
      console.error('Save error:', error);
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (id, field, value) => {
    setContactDetails(prev => prev.map(detail => 
      detail.id === id ? { ...detail, [field]: value } : detail
    ));
  };

  if (loading) {
    return <div className="editor-loading">جاري التحميل...</div>;
  }

  const getContactTypeLabel = (type) => {
    const labels = {
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      whatsapp: 'واتساب',
      address: 'العنوان'
    };
    return labels[type] || type;
  };

  return (
    <div className="editor-container">
      <div className="editor-header">
        <h2>إدارة بيانات التواصل</h2>
        {message && (
          <div className={`editor-message ${message.includes('نجح') || message.includes('success') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </div>

      <div className="editor-items-list">
        {contactDetails.map((detail) => (
          <div key={detail.id} className="editor-item-card">
            <div className="editor-item-content" style={{ flex: 1 }}>
              <h4>{getContactTypeLabel(detail.contact_type)}</h4>
              <div className="editor-grid" style={{ marginTop: '15px', gap: '15px' }}>
                <div className="editor-column">
                  <div className="editor-form-group">
                    <label>القيمة (عربي)</label>
                    <input
                      type="text"
                      value={detail.value_ar || ''}
                      onChange={(e) => handleChange(detail.id, 'value_ar', e.target.value)}
                      placeholder="القيمة بالعربية"
                    />
                  </div>
                </div>
                <div className="editor-column">
                  <div className="editor-form-group">
                    <label>Value (English)</label>
                    <input
                      type="text"
                      value={detail.value_en || ''}
                      onChange={(e) => handleChange(detail.id, 'value_en', e.target.value)}
                      placeholder="Value in English"
                    />
                  </div>
                </div>
              </div>
              <div className="editor-form-group" style={{ marginTop: '15px' }}>
                <label>الرابط (URL)</label>
                <input
                  type="text"
                  value={detail.url || ''}
                  onChange={(e) => handleChange(detail.id, 'url', e.target.value)}
                  placeholder="mailto:email@example.com أو tel:+96600000000 أو https://wa.me/..."
                />
              </div>
              <div style={{ display: 'flex', gap: '15px', marginTop: '15px' }}>
                <div className="editor-form-group" style={{ flex: 1 }}>
                  <label>ترتيب العرض</label>
                  <input
                    type="number"
                    value={detail.display_order || 0}
                    onChange={(e) => handleChange(detail.id, 'display_order', parseInt(e.target.value) || 0)}
                  />
                </div>
                <div className="editor-form-group" style={{ flex: 1 }}>
                  <label>
                    <input
                      type="checkbox"
                      checked={detail.is_active}
                      onChange={(e) => handleChange(detail.id, 'is_active', e.target.checked)}
                      style={{ marginLeft: '10px' }}
                    />
                    {' '}نشط
                  </label>
                </div>
              </div>
            </div>
            <div className="editor-item-actions">
              <button 
                className="editor-btn-sm editor-btn-edit" 
                onClick={() => handleSave(detail)}
                disabled={saving}
              >
                {saving ? 'جاري الحفظ...' : 'حفظ'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactDetailsEditor;

